/**
 * CanvasLocaleContext - Provides current locale for canvas screen node previews
 *
 * Used by FlowOnboardingScreenNode to render ScreenView with the selected locale.
 * Provided by the active canvas editor that manages session-level locale state.
 *
 * Architecture: React Context is used instead of updating every node via updateNodeData
 * because useContext triggers re-renders through React.memo boundaries automatically.
 */
import { createContext, useContext } from 'react';

export interface CanvasLocaleContextValue {
  locale: string;
}

export const CanvasLocaleContext = createContext<CanvasLocaleContextValue>({
  locale: 'en-US',
});

export const useCanvasLocale = () => useContext(CanvasLocaleContext);
